import { Toaster as Sonner } from 'sonner';
import type { ToasterProps } from 'sonner';

import { useTheme } from '@/components/theme-provider';

/*
 * sonner Toaster wired to the app theme + restyled to the bevel/mono system
 * via CSS variables (sonner reads `--normal-*`).
 */
function Toaster(props: ToasterProps) {
  const { theme } = useTheme();

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast: 'bevel bg-panel text-text shadow-hard-sm font-mono text-sm rounded-none',
          description: 'text-dim',
          actionButton: 'bevel bg-orange-cta text-orange-cta-tx font-display text-[10px] uppercase',
          cancelButton: 'bevel bg-btn text-titletext font-display text-[10px] uppercase',
        },
      }}
      style={
        {
          '--normal-bg': 'var(--panel)',
          '--normal-text': 'var(--text)',
          '--normal-border': 'var(--line)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
}

export { Toaster };
